// AppointmentTableWidget.jsx
import { Link } from "react-router-dom"

const STATUS_STYLES = {
  Scheduled: "bg-blue-100 text-blue-700",
  "In Progress": "bg-amber-100 text-amber-800",
  Completed: "bg-green-100 text-green-700",
  Cancelled: "bg-red-100 text-red-700",
}

export default function DrAppointmentTableWidget({ data }) {

  const onStart = (row) => {
    // open consultation slide-over with row context
  }
  const onReschedule = (row) => {
    // open reschedule modal
  }
  const onCancel = (row) => {
    // open confirm cancel modal
  }



  return (
    <div className="rounded-xl border bg-white">
      <div className="flex items-center justify-between border-b px-4 py-3">
        <h2 className="text-[12px] font-semibold text-slate-700">Appointment Schedule</h2>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full table-auto" aria-label="Doctor appointment schedule">
          <thead className="bg-slate-50 text-left">
            <tr>
              <th scope="col" className="px-4 py-2 text-[12px] font-semibold text-slate-600">Appointment ID</th>
              <th scope="col" className="px-4 py-2 text-[12px] font-semibold text-slate-600">Time Slot</th>
              <th scope="col" className="px-4 py-2 text-[12px] font-semibold text-slate-600">Patient Name</th>
              <th scope="col" className="px-4 py-2 text-[12px] font-semibold text-slate-600">Age</th>
              <th scope="col" className="px-4 py-2 text-[12px] font-semibold text-slate-600">Department / Room No.</th>
              <th scope="col" className="px-4 py-2 text-[12px] font-semibold text-slate-600">Status</th>
            </tr>
          </thead>

          <tbody>
            {data?.appointmentSchedules?.length === 0 && (
              <tr>
                <td colSpan={7} className="px-4 py-6 text-center text-[12px] text-slate-500">
                  No appointments found
                </td>
              </tr>
            )}

            {data?.appointmentSchedules?.map((row, index) => (
              <tr key={index} className="border-t hover:bg-slate-50">
                  <td className="px-4 py-2 text-[12px] text-slate-800">{row.appointmentID}</td>
                  <td className="px-4 py-2 text-[12px] text-slate-700">{row.timeSlot}</td>
                  <td className="px-4 py-2 text-[12px]">
                  <div
                    className="text-sky-700"
                    aria-label={`Open patient record for ${row.patientName}`}
                  >
                    {row.patientName}
                  </div>
                </td>
                <td className="px-4 py-2 text-[12px] text-slate-700">{row.age}</td>
                <td className="px-4 py-2 text-[12px] text-slate-700">{row.department}</td>
                <td className="px-4 py-2 text-[12px]">
                  <span className={`inline-flex rounded px-2 py-1 text-xs ${STATUS_STYLES[row.status] || "bg-slate-100 text-slate-700"}`}>
                    {row.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
